import React, {useEffect, useState} from 'react';
import ThemeService from "../../services/ThemeService";
import {message, Spin} from "antd";
import SubDealerService from "../../services/SubdealerService";
import {showErrors} from "../../services/utils";
import { useDispatch } from 'react-redux';
import { onTopNavColorChange } from 'redux/actions/Theme';



function ThemeBootstrap({ children }) {

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);

  useEffect(() => {

    let cancelled = false;

    const cachedConfig = ThemeService.getConfiguration();

    // console.log('ThemeService.getConfiguration():', cachedConfig)

    if (cachedConfig) {
      ThemeService.applyTheme(cachedConfig);
      setLoading(false);
      return;
    }

    SubDealerService.getSubDealerProfile()
      .then((response) => {

        if (cancelled) {
          return;
        }

        ThemeService.applyTheme(response);
        ThemeService.saveConfiguration(response);

        dispatch(onTopNavColorChange(response.color_main));

      })
      .catch((error) => {
        console.log('error:', error);

        const {errorMsg} = showErrors(error);
        message.error(errorMsg);
      })
      .finally(() => {
        setLoading(false);
      });

    return () => {
      cancelled = true
    }
  }, [dispatch])

  if (loading) {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Spin
          size="large"
        />
      </div>
    );
  }

  return children;
}


export default ThemeBootstrap